var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAdvanceBequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 94,
    viewBox: "0 0 141 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 43.5C80 49.299 75.299 54 69.5 54C63.701 54 59 49.299 59 43.5C59 37.701 63.701 33 69.5 33C75.299 33 80 37.701 80 43.5Z",
    fill: "#40946A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7229 42.1229H70.8769V39.2769C70.8769 38.516 70.2608 37.8999 69.4999 37.8999C68.739 37.8999 68.1229 38.516 68.1229 39.2769V42.1229H65.2769C64.5167 42.1229 63.8999 42.739 63.8999 43.4999C63.8999 44.2601 64.5167 44.8769 65.2769 44.8769H68.1229V47.7222C68.1229 48.4831 68.739 49.0999 69.4999 49.0999C70.2608 49.0999 70.8769 48.4831 70.8769 47.7222V44.8762H73.7229C74.4831 44.8762 75.0999 44.2601 75.0999 43.4992C75.0999 42.739 74.4831 42.1229 73.7229 42.1229Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.325 54.9038L96.767 54.913L96.749 43.8616C96.7486 43.5524 96.9989 43.3015 97.308 43.301L102.746 43.2935C103.056 43.2931 103.307 43.5434 103.307 43.8524L103.325 54.9038Z",
    fill: "#093E62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.169 43.0938L96.6021 59.6425L96.6372 84.8005C96.6381 85.4642 97.1769 86.0014 97.8406 86.0005L130.617 85.9548C131.281 85.9539 131.818 85.415 131.817 84.7514L131.782 59.5934L114.169 43.0938Z",
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.17 43.0952L111.512 45.5359L128.602 61.6581V85.8414L130.618 85.9562C131.281 85.9553 131.819 85.4165 131.818 84.7529L131.783 59.5949L114.17 43.0952Z",
    fill: "#B0D2EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.979 65.1374C137.386 65.1383 136.791 64.922 136.324 64.4846L114.169 43.7302L92.0722 64.5464C91.1011 65.4614 89.572 65.4156 88.6574 64.4445C87.7425 63.4734 87.7881 61.9446 88.7593 61.0298L112.508 38.6574C113.437 37.7827 114.885 37.7806 115.816 38.6527L139.628 60.9586C140.601 61.8707 140.651 63.3995 139.739 64.3731C139.264 64.8798 138.622 65.1364 137.979 65.1374Z",
    fill: "#093E62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.923 65.3779H112.164C110.85 65.3779 109.785 64.3129 109.785 62.9988V58.2405C109.785 56.9264 110.85 55.8613 112.164 55.8613H116.923C118.237 55.8613 119.302 56.9264 119.302 58.2405V62.9988C119.302 64.3129 118.237 65.3779 116.923 65.3779Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.302 59.8266H115.337V55.8613H113.75V59.8266H109.785V61.4127H113.75V65.3779H115.337V61.4127H119.302V59.8266Z",
    fill: "#B0D2EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2617 75.6483C90.2617 75.2304 90.6005 74.8916 91.0184 74.8916H112.961C113.379 74.8916 113.718 75.2304 113.718 75.6483V86.998C113.718 87.4159 113.379 87.7547 112.961 87.7547H91.0184C90.6005 87.7547 90.2617 87.4159 90.2617 86.998V75.6483Z",
    fill: "#E0EAE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0179 73H112.961C114.423 73 115.609 74.1857 115.609 75.6483V86.998C115.609 88.4606 114.423 89.6463 112.961 89.6463H91.0179C89.5553 89.6463 88.3696 88.4606 88.3696 86.998V75.6483C88.3696 74.1857 89.5553 73 91.0179 73ZM91.0179 74.8916C90.6 74.8916 90.2613 75.2304 90.2613 75.6483V86.998C90.2613 87.4159 90.6 87.7547 91.0179 87.7547H112.961C113.379 87.7547 113.717 87.4159 113.717 86.998V75.6483C113.717 75.2304 113.379 74.8916 112.961 74.8916H91.0179Z",
    fill: "#40946A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6665 75.8376C93.6665 76.9868 92.7349 77.9184 91.5857 77.9184C90.4365 77.9184 89.5049 76.9868 89.5049 75.8376C89.5049 74.6884 90.4365 73.7568 91.5857 73.7568C92.7349 73.7568 93.6665 74.6884 93.6665 75.8376Z",
    fill: "#40946A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6665 86.8088C93.6665 87.958 92.7349 88.8896 91.5857 88.8896C90.4365 88.8896 89.5049 87.958 89.5049 86.8088C89.5049 85.6596 90.4365 84.728 91.5857 84.728C92.7349 84.728 93.6665 85.6596 93.6665 86.8088Z",
    fill: "#40946A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.474 75.8376C114.474 76.9868 113.542 77.9184 112.393 77.9184C111.244 77.9184 110.312 76.9868 110.312 75.8376C110.312 74.6884 111.244 73.7568 112.393 73.7568C113.542 73.7568 114.474 74.6884 114.474 75.8376Z",
    fill: "#40946A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9358 81.3229C95.9358 82.1586 95.2583 82.8362 94.4225 82.8362C93.5867 82.8362 92.9092 82.1586 92.9092 81.3229C92.9092 80.4871 93.5867 79.8096 94.4225 79.8096C95.2583 79.8096 95.9358 80.4871 95.9358 81.3229Z",
    fill: "#40946A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.069 81.3229C111.069 82.1586 110.392 82.8362 109.556 82.8362C108.72 82.8362 108.042 82.1586 108.042 81.3229C108.042 80.4871 108.72 79.8096 109.556 79.8096C110.392 79.8096 111.069 80.4871 111.069 81.3229Z",
    fill: "#40946A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.773 81.3233C105.773 83.4127 104.079 85.1065 101.989 85.1065C99.8999 85.1065 98.2061 83.4127 98.2061 81.3233C98.2061 79.2339 99.8999 77.54 101.989 77.54C104.079 77.54 105.773 79.2339 105.773 81.3233Z",
    fill: "#40946A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.249 82.8748C102.696 82.8748 103.073 82.7003 103.379 82.3514L103.881 82.8559C103.688 83.0955 103.446 83.2783 103.156 83.4045C102.87 83.5306 102.553 83.5936 102.207 83.5936C101.856 83.5936 101.53 83.5264 101.227 83.3918C100.929 83.2573 100.675 83.0682 100.466 82.8244C100.26 82.5805 100.115 82.2989 100.03 81.9794H99.3413V81.538H99.9519C99.9478 81.4918 99.9458 81.4203 99.9458 81.3237C99.9458 81.227 99.9478 81.1555 99.9519 81.1093H99.3413V80.6679H100.03C100.115 80.3484 100.26 80.0668 100.466 79.823C100.675 79.5792 100.929 79.39 101.227 79.2555C101.53 79.121 101.856 79.0537 102.207 79.0537C102.553 79.0537 102.87 79.1168 103.156 79.2429C103.446 79.369 103.688 79.5518 103.881 79.7914L103.379 80.2896C103.073 79.9449 102.696 79.7725 102.249 79.7725C101.927 79.7725 101.642 79.8524 101.397 80.0121C101.155 80.1719 100.976 80.3905 100.859 80.6679H102.594V81.1093H100.744C100.736 81.2018 100.732 81.2732 100.732 81.3237C100.732 81.3741 100.736 81.4456 100.744 81.538H102.594V81.9794H100.859C100.976 82.2569 101.155 82.4755 101.397 82.6352C101.642 82.7949 101.927 82.8748 102.249 82.8748Z",
    fill: "#E0EAE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.474 86.8083C114.474 87.9575 113.542 88.8891 112.393 88.8891C111.244 88.8891 110.312 87.9575 110.312 86.8083C110.312 85.6591 111.244 84.7275 112.393 84.7275C113.542 84.7275 114.474 85.6591 114.474 86.8083Z",
    fill: "#40946A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.285 93.4713C121.731 93.4713 125.336 89.8665 125.336 85.4198C125.336 80.973 121.731 77.3682 117.285 77.3682C112.838 77.3682 109.233 80.973 109.233 85.4198C109.233 89.8665 112.838 93.4713 117.285 93.4713Z",
    fill: "#F6D738"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.284 92.2529C121.058 92.2529 124.118 89.1936 124.118 85.4197C124.118 81.6458 121.058 78.5864 117.284 78.5864C113.511 78.5864 110.451 81.6458 110.451 85.4197C110.451 89.1936 113.511 92.2529 117.284 92.2529Z",
    fill: "#F3CC30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.142 79.769C121.769 80.8635 122.101 82.1444 122.035 83.498C121.85 87.2673 118.644 90.1731 114.874 89.9875C113.565 89.9231 112.361 89.4944 111.353 88.8042C112.473 90.7577 114.534 92.117 116.95 92.2355C120.719 92.4207 123.925 89.5153 124.11 85.746C124.231 83.2861 123.035 81.0659 121.142 79.769Z",
    fill: "#EDBD31"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.624 85.7662C111.788 82.439 114.618 79.8739 117.945 80.0373C119.89 80.133 121.574 81.1398 122.605 82.6242C121.654 80.7671 119.764 79.4554 117.53 79.3453C114.202 79.1818 111.373 81.7465 111.209 85.0742C111.141 86.4567 111.544 87.7532 112.278 88.808C111.812 87.8995 111.571 86.8599 111.624 85.7662Z",
    fill: "#F7DB5E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.279 88.2135C118.977 88.2135 119.566 87.9536 120.044 87.4338L120.827 88.1853C120.525 88.5422 120.147 88.8147 119.694 89.0025C119.248 89.1904 118.754 89.2843 118.213 89.2843C117.666 89.2843 117.157 89.1841 116.685 88.9837C116.219 88.7833 115.823 88.5015 115.496 88.1383C115.175 87.7751 114.949 87.3555 114.817 86.8796H113.741V86.222H114.694C114.688 86.1532 114.685 86.0467 114.685 85.9027C114.685 85.7586 114.688 85.6522 114.694 85.5833H113.741V84.9257H114.817C114.949 84.4498 115.175 84.0302 115.496 83.667C115.823 83.3038 116.219 83.022 116.685 82.8216C117.157 82.6212 117.666 82.521 118.213 82.521C118.754 82.521 119.248 82.6149 119.694 82.8028C120.147 82.9907 120.525 83.2631 120.827 83.62L120.044 84.3621C119.566 83.8486 118.977 83.5919 118.279 83.5919C117.776 83.5919 117.333 83.7108 116.949 83.9488C116.572 84.1868 116.292 84.5124 116.109 84.9257H118.817V85.5833H115.93C115.917 85.7211 115.911 85.8275 115.911 85.9027C115.911 85.9778 115.917 86.0843 115.93 86.222H118.817V86.8796H116.109C116.292 87.2929 116.572 87.6185 116.949 87.8565C117.333 88.0945 117.776 88.2135 118.279 88.2135Z",
    fill: "#DBAD27"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.367188,
    width: 37.792,
    height: 48.2898,
    rx: 2,
    fill: "#E7F0F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.811,
    y: 11.1782,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    fill: "#B9D6EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76562,
    y: 10.4575,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76562,
    y: 17.6646,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76562,
    y: 24.8721,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76562,
    y: 32.0801,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    fill: "#B9D6EC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.811,
    y: 18.3857,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    fill: "#B9D6EC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.811,
    y: 25.5928,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    fill: "#B9D6EC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.811,
    y: 32.8008,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    fill: "#B9D6EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2817,
    y: 6.04834,
    width: 37.792,
    height: 48.2898,
    rx: 2,
    transform: "rotate(10.3871 16.2817 6.04834)",
    fill: "#B9D6EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9663,
    y: 18.6313,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    transform: "rotate(10.3871 24.9663 18.6313)",
    fill: "#2974B2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1338,
    y: 17.0127,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    transform: "rotate(10.3871 20.1338 17.0127)",
    fill: "#093E62"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.834,
    y: 24.1021,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    transform: "rotate(10.3871 18.834 24.1021)",
    fill: "#093E62"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5352,
    y: 31.1914,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    transform: "rotate(10.3871 17.5352 31.1914)",
    fill: "#093E62"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2354,
    y: 38.2808,
    width: 2.88298,
    height: 2.88298,
    rx: 1,
    transform: "rotate(10.3871 16.2354 38.2808)",
    fill: "#093E62"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 25.7207,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    transform: "rotate(10.3871 23.667 25.7207)",
    fill: "#2974B2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3672,
    y: 32.8101,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    transform: "rotate(10.3871 22.3672 32.8101)",
    fill: "#2974B2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0679,
    y: 39.8994,
    width: 20.1808,
    height: 1.44149,
    rx: 0.720744,
    transform: "rotate(10.3871 21.0679 39.8994)",
    fill: "#2974B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAdvanceBequest);
export default __webpack_public_path__ + "static/media/imgAdvanceBequest.d061019f92ac6b2b2a8198c55ae985ac.svg";
export { ForwardRef as ReactComponent };